export default "__VITE_ASSET__5081b923__"